import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TAVAHOT_PRIVACY_URL } from "../constants/policies";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Use the hosted policy as the source of truth.
    window.location.replace(TAVAHOT_PRIVACY_URL);
  }, []);

  return (
    <div className="w-full min-h-screen pt-24 px-4">
      <div className="max-w-3xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="text-sm text-gray-600 underline mb-6"
        >
          Back
        </button>
        <h1 className="text-3xl font-bold text-[#171725] mb-6">Privacy Policy</h1>
        <div className="text-gray-700 leading-7 space-y-4">
          <p>
            Redirecting to our Privacy Policy…
          </p>
          <p>
            If you are not redirected automatically, open{" "}
            <a
              href={TAVAHOT_PRIVACY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;


